import { lgStyle, mdStyle, smStyle } from '@/components/Adapter'
import styled from 'styled-components'

export const PriceMainStyled = styled.main`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 40px !important;
  background: var(--color-bg-1);
  position: relative;
  z-index: 1;

  ${smStyle} {
    gap: 40px;
    padding-bottom: 80px !important;
  }

  ${mdStyle} {
    gap: 80px;
    padding-bottom: 80px !important;
  }

  ${lgStyle} {
    gap: 80px;
    padding-bottom: 120px !important;
  }
`

/**
 * @description: 未来事件容器
 * @return {*}
 */
export const PriceFutureEventGateLearn = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${mdStyle} {
    display: grid;
    grid-template-columns: calc(100% - 16px - 380px) 380px;
    gap: 16px;
  }

  ${lgStyle} {
    display: grid;
    grid-template-columns: calc(100% - 24px - 452px) 452px;
    gap: 24px;
  }
`

export const PriceAnnouncementContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
